<template>
  <div>
    <header :class="['l-header__wrapper',showMenu?'opened':'']">
      <div class="l-header-logo">
        <router-link class="l-header-logo__link" to="/">
          <svg class="inline-svg logo__white svg-inline--transparent" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="130" height="40" viewBox="0 0 130 38">
            <path fill="#FFF" fill-rule="nonzero" d="M77.37 37.923c-.918-.185-1.683-.676-1.995-1.281-.127-.248-.252-.825-.204-.948.022-.06.159-.077.58-.077h.55l.035.227c.142.885.967 1.34 2.423 1.338.953-.002 1.785-.24 2.022-.578.269-.383.217-.871-.124-1.153-.276-.229-.718-.358-2.011-.589-1.6-.285-1.881-.351-2.255-.528-.631-.299-.906-.705-.908-1.34-.005-1.436 1.5-2.27 3.695-2.05.748.075 1.158.178 1.617.404.588.29 1.008.866 1.097 1.504l.036.264h-.586c-.521 0-.586-.01-.587-.097-.001-.221-.273-.677-.504-.845-.902-.654-2.99-.528-3.448.208-.183.296-.178.726.01.932.236.255.532.342 2.14.63 1.953.35 2.409.505 2.79.944.298.345.372.561.372 1.09 0 .434-.02.537-.149.783-.19.362-.466.602-.965.839-.62.295-1.27.405-2.355.4-.513-.003-1.075-.037-1.277-.077zm-30.425-3.446v-3.361h2.28c2.56 0 2.794.025 3.364.368.446.269.552.38.752.786.149.302.173.411.17.768-.004.797-.476 1.44-1.297 1.772l-.41.165-1.791.02-1.79.018v2.826h-1.278v-3.362zm4.423-.388c.6-.178.875-.519.877-1.084 0-.417-.16-.672-.545-.86-.387-.19-.958-.25-2.353-.25l-1.125-.001v2.278h1.434c1.108 0 1.496-.019 1.712-.083zm2.105 3.575c.087-.168 1.19-2.42 2.562-5.229l.644-1.32H58.084l.505 1.07c1.3 2.752 2.624 5.59 2.624 5.62 0 .019-.296.034-.658.034h-.66l-.434-.972-.435-.973-1.724.001-1.724.001-.444.97-.444.97-.654.002-.653.001.09-.175zm4.502-4.02c-.338-.78-.628-1.417-.645-1.417-.025 0-1.219 2.499-1.319 2.76-.023.06.21.074 1.275.074h1.304l-.615-1.417zm4.793.833v-3.361h2.405c2.555 0 2.8.019 3.444.269.72.279 1.09.802 1.09 1.537 0 .657-.315 1.18-.889 1.473l-.234.12.28.13c.327.15.596.482.645.793.018.113.056.578.086 1.032.055.862.11 1.048.333 1.119.062.02.113.084.113.143 0 .1-.046.107-.749.107h-.748l-.034-.153a3.4 3.4 0 0 0-.059-.233 11.53 11.53 0 0 1-.074-.9c-.051-.847-.084-.97-.326-1.23-.271-.291-.537-.331-2.382-.36l-1.68-.025v2.901h-1.221v-3.362zm4.872-.44c.358-.113.651-.36.738-.624.093-.283.043-.82-.095-1.006-.174-.236-.519-.398-.97-.457-.225-.029-1.065-.054-1.866-.055l-1.458-.001v2.292l1.68-.028c1.353-.023 1.736-.046 1.971-.12zm4.288.44v-3.361h1.221V37.839h-1.22v-3.362zm39.973-2.064l-.708-.051-.458-.034v-3.094l.912.033c1.034.036 1.539-.023 2.206-.26 1.092-.386 1.937-1.165 2.546-2.345.255-.495.604-1.435.693-1.867l.037-.182-.38.028c-.208.015-.922.04-1.586.058l-1.207.03-.438-.904-1.034-2.127-1-2.056c-.22-.459-.708-1.459-1.082-2.223-.374-.764-.86-1.764-1.083-2.222-.221-.459-.696-1.434-1.055-2.167-2.09-4.277-2.747-5.64-2.747-5.7 0-.03 1.324-.05 3.345-.05h3.345l.634 1.458c1.632 3.748 2.825 6.476 3.447 7.876.373.84.848 1.94 1.056 2.444.71 1.726 1.254 2.966 1.306 2.983.029.009.288-.752.577-1.691.288-.94.684-2.17.88-2.736.859-2.488 1.612-4.685 2.313-6.751.415-1.223.85-2.498.968-2.834l.213-.611 3.2-.015c1.76-.007 3.199-.002 3.199.012s-.284.783-.631 1.71c-.347.925-.92 2.457-1.273 3.405a56127.836 56127.836 0 0 1-3.187 8.557c-2.254 6.075-2.434 6.514-3.145 7.667-1.539 2.498-3.307 3.402-7.115 3.64-.82.05-2.151.06-2.748.019zM9 24.91c-2.488-.099-4.601-.397-5.932-.836-1.83-.605-2.84-1.857-3.033-3.759C0 19.991-.01 19.6.01 19.447l.037-.277h3.24c1.783 0 3.241.006 3.24.013 0 .008-.037.152-.082.32-.165.616-.083 1.081.262 1.473.67.76 2.303 1.138 4.935 1.138 2.68 0 4.472-.367 5.316-1.09.532-.455.681-1.258.366-1.962-.26-.577-.771-.94-1.663-1.175-.385-.102-.689-.124-2.276-.166-5.38-.143-7.102-.266-8.954-.641-1.478-.3-2.25-.654-2.956-1.355-.376-.375-.523-.57-.71-.945-.403-.811-.475-1.187-.48-2.473-.002-1 .01-1.155.126-1.553.07-.243.219-.618.33-.833.261-.505.954-1.212 1.466-1.496 1.012-.562 2.536-.896 5.16-1.129 1.379-.122 7.245-.143 8.572-.03 2.476.211 3.936.515 4.94 1.03.867.442 1.583 1.357 1.832 2.34.09.357.195 1.113.195 1.406v.182H16.763l-.099-.457c-.186-.87-.518-1.303-1.138-1.488-.603-.18-1.165-.226-3.113-.26-1.976-.034-2.792.011-3.672.204-.767.167-1.285.41-1.66.776-.375.368-.466.608-.458 1.206.012.863.31 1.37.907 1.54.581.168 2.414.305 5.66.424 4.944.182 7.69.591 8.944 1.333.513.304.997.84 1.265 1.404.369.773.422 1.074.423 2.375 0 1.281-.07 1.661-.446 2.407-1.05 2.08-3.397 2.923-8.909 3.204-.957.049-4.415.06-5.468.02zm39.251-.021c-5.51-.304-7.6-1.228-8.302-3.67-.086-.3-.127-.634-.149-1.23l-.03-.82h3.255c1.79 0 3.255.015 3.255.033 0 .019-.04.188-.089.375-.346 1.326.62 2.101 3.032 2.436.805.111 3.833.094 4.695-.026 1.762-.247 2.84-.743 3.192-1.47.193-.398.184-1.052-.022-1.473-.28-.573-.785-.92-1.68-1.16-.38-.1-.687-.122-2.271-.165-4.46-.119-6.026-.204-7.579-.414-2.605-.351-3.897-.897-4.696-1.984-.55-.747-.791-1.535-.839-2.744-.075-1.887.419-3.08 1.636-3.95.985-.704 2.663-1.1 5.732-1.351 1.168-.096 5.883-.134 7.3-.058 4.796.254 6.685.933 7.52 2.703.224.473.384 1.143.428 1.789l.036.514-3.071-.014-3.071-.015-.129-.525c-.36-1.471-.834-1.637-4.683-1.64-1.825-.001-2.226.013-2.745.1-1.071.181-1.86.516-2.243.953-.275.313-.359.62-.33 1.207.04.866.3 1.289.894 1.46.566.162 2.425.3 5.645.418 5.064.187 7.853.614 9.035 1.385.524.342.88.745 1.156 1.307.297.606.392.965.473 1.776.12 1.204-.078 2.341-.57 3.27-.25.467-1.015 1.238-1.523 1.532-1.278.738-3.124 1.153-6.239 1.401-.978.078-5.881.113-7.023.05zm41.666.025c-3.506-.188-5.54-.564-7.023-1.298-.986-.488-1.526-1.02-2.053-2.017-.459-.868-.746-1.886-.954-3.375-.14-1.006-.14-3.76 0-4.69.292-1.947.912-3.334 1.894-4.238.482-.445.838-.67 1.53-.969 1.188-.512 2.817-.847 5.163-1.06 1.1-.1 5.904-.1 6.967 0 2.894.272 4.818.79 5.91 1.592 1.125.827 1.845 2.208 2.173 4.17.094.562.202 2.372.215 3.598l.002.208H86.201l-.038.203c-.067.36.02 1.736.14 2.227.208.84.594 1.436 1.17 1.804.872.556 3.04.823 5.775.711 2.822-.116 3.627-.413 4-1.478.064-.18.13-.522.147-.758l.032-.431h6.319l-.035.625c-.059 1.066-.202 1.567-.624 2.19-1.063 1.566-3.409 2.495-7.286 2.885-.812.081-4.927.152-5.885.1zM97.45 13.46c-.084-1.908-.582-2.585-2.132-2.899-1.504-.304-4.548-.36-6.178-.113-1.062.16-1.797.45-2.14.845-.413.475-.675 1.304-.73 2.306l-.034.625h11.248l-.034-.764zM28.68 16.058V7.39H35.009v17.336H28.68v-8.668zm39.75-3.695V0h6.33v24.726H68.43V12.363zM28.68 1.75V0H35.009v3.5H28.68V1.75z" />
          </svg>
          <svg class="svg-inline logo svg-inline--default" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="130" height="40" viewBox="0 0 130 38">
            <path fill="#000" fill-rule="nonzero" d="M77.37 37.923c-.918-.185-1.683-.676-1.995-1.281-.127-.248-.252-.825-.204-.948.022-.06.159-.077.58-.077h.55l.035.227c.142.885.967 1.34 2.423 1.338.953-.002 1.785-.24 2.022-.578.269-.383.217-.871-.124-1.153-.276-.229-.718-.358-2.011-.589-1.6-.285-1.881-.351-2.255-.528-.631-.299-.906-.705-.908-1.34-.005-1.436 1.5-2.27 3.695-2.05.748.075 1.158.178 1.617.404.588.29 1.008.866 1.097 1.504l.036.264h-.586c-.521 0-.586-.01-.587-.097-.001-.221-.273-.677-.504-.845-.902-.654-2.99-.528-3.448.208-.183.296-.178.726.01.932.236.255.532.342 2.14.63 1.953.35 2.409.505 2.79.944.298.345.372.561.372 1.09 0 .434-.02.537-.149.783-.19.362-.466.602-.965.839-.62.295-1.27.405-2.355.4-.513-.003-1.075-.037-1.277-.077zm-30.425-3.446v-3.361h2.28c2.56 0 2.794.025 3.364.368.446.269.552.38.752.786.149.302.173.411.17.768-.004.797-.476 1.44-1.297 1.772l-.41.165-1.791.02-1.79.018v2.826h-1.278v-3.362zm4.423-.388c.6-.178.875-.519.877-1.084 0-.417-.16-.672-.545-.86-.387-.19-.958-.25-2.353-.25l-1.125-.001v2.278h1.434c1.108 0 1.496-.019 1.712-.083zm2.105 3.575c.087-.168 1.19-2.42 2.562-5.229l.644-1.32H58.084l.505 1.07c1.3 2.752 2.624 5.59 2.624 5.62 0 .019-.296.034-.658.034h-.66l-.434-.972-.435-.973-1.724.001-1.724.001-.444.97-.444.97-.654.002-.653.001.09-.175zm4.502-4.02c-.338-.78-.628-1.417-.645-1.417-.025 0-1.219 2.499-1.319 2.76-.023.06.21.074 1.275.074h1.304l-.615-1.417zm4.793.833v-3.361h2.405c2.555 0 2.8.019 3.444.269.72.279 1.09.802 1.09 1.537 0 .657-.315 1.18-.889 1.473l-.234.12.28.13c.327.15.596.482.645.793.018.113.056.578.086 1.032.055.862.11 1.048.333 1.119.062.02.113.084.113.143 0 .1-.046.107-.749.107h-.748l-.034-.153a3.4 3.4 0 0 0-.059-.233 11.53 11.53 0 0 1-.074-.9c-.051-.847-.084-.97-.326-1.23-.271-.291-.537-.331-2.382-.36l-1.68-.025v2.901h-1.221v-3.362zm4.872-.44c.358-.113.651-.36.738-.624.093-.283.043-.82-.095-1.006-.174-.236-.519-.398-.97-.457-.225-.029-1.065-.054-1.866-.055l-1.458-.001v2.292l1.68-.028c1.353-.023 1.736-.046 1.971-.12zm4.288.44v-3.361h1.221V37.839h-1.22v-3.362zm39.973-2.064l-.708-.051-.458-.034v-3.094l.912.033c1.034.036 1.539-.023 2.206-.26 1.092-.386 1.937-1.165 2.546-2.345.255-.495.604-1.435.693-1.867l.037-.182-.38.028c-.208.015-.922.04-1.586.058l-1.207.03-.438-.904-1.034-2.127-1-2.056c-.22-.459-.708-1.459-1.082-2.223-.374-.764-.86-1.764-1.083-2.222-.221-.459-.696-1.434-1.055-2.167-2.09-4.277-2.747-5.64-2.747-5.7 0-.03 1.324-.05 3.345-.05h3.345l.634 1.458c1.632 3.748 2.825 6.476 3.447 7.876.373.84.848 1.94 1.056 2.444.71 1.726 1.254 2.966 1.306 2.983.029.009.288-.752.577-1.691.288-.94.684-2.17.88-2.736.859-2.488 1.612-4.685 2.313-6.751.415-1.223.85-2.498.968-2.834l.213-.611 3.2-.015c1.76-.007 3.199-.002 3.199.012s-.284.783-.631 1.71c-.347.925-.92 2.457-1.273 3.405a56127.836 56127.836 0 0 1-3.187 8.557c-2.254 6.075-2.434 6.514-3.145 7.667-1.539 2.498-3.307 3.402-7.115 3.64-.82.05-2.151.06-2.748.019zM9 24.91c-2.488-.099-4.601-.397-5.932-.836-1.83-.605-2.84-1.857-3.033-3.759C0 19.991-.01 19.6.01 19.447l.037-.277h3.24c1.783 0 3.241.006 3.24.013 0 .008-.037.152-.082.32-.165.616-.083 1.081.262 1.473.67.76 2.303 1.138 4.935 1.138 2.68 0 4.472-.367 5.316-1.09.532-.455.681-1.258.366-1.962-.26-.577-.771-.94-1.663-1.175-.385-.102-.689-.124-2.276-.166-5.38-.143-7.102-.266-8.954-.641-1.478-.3-2.25-.654-2.956-1.355-.376-.375-.523-.57-.71-.945-.403-.811-.475-1.187-.48-2.473-.002-1 .01-1.155.126-1.553.07-.243.219-.618.33-.833.261-.505.954-1.212 1.466-1.496 1.012-.562 2.536-.896 5.16-1.129 1.379-.122 7.245-.143 8.572-.03 2.476.211 3.936.515 4.94 1.03.867.442 1.583 1.357 1.832 2.34.09.357.195 1.113.195 1.406v.182H16.763l-.099-.457c-.186-.87-.518-1.303-1.138-1.488-.603-.18-1.165-.226-3.113-.26-1.976-.034-2.792.011-3.672.204-.767.167-1.285.41-1.66.776-.375.368-.466.608-.458 1.206.012.863.31 1.37.907 1.54.581.168 2.414.305 5.66.424 4.944.182 7.69.591 8.944 1.333.513.304.997.84 1.265 1.404.369.773.422 1.074.423 2.375 0 1.281-.07 1.661-.446 2.407-1.05 2.08-3.397 2.923-8.909 3.204-.957.049-4.415.06-5.468.02zm39.251-.021c-5.51-.304-7.6-1.228-8.302-3.67-.086-.3-.127-.634-.149-1.23l-.03-.82h3.255c1.79 0 3.255.015 3.255.033 0 .019-.04.188-.089.375-.346 1.326.62 2.101 3.032 2.436.805.111 3.833.094 4.695-.026 1.762-.247 2.84-.743 3.192-1.47.193-.398.184-1.052-.022-1.473-.28-.573-.785-.92-1.68-1.16-.38-.1-.687-.122-2.271-.165-4.46-.119-6.026-.204-7.579-.414-2.605-.351-3.897-.897-4.696-1.984-.55-.747-.791-1.535-.839-2.744-.075-1.887.419-3.08 1.636-3.95.985-.704 2.663-1.1 5.732-1.351 1.168-.096 5.883-.134 7.3-.058 4.796.254 6.685.933 7.52 2.703.224.473.384 1.143.428 1.789l.036.514-3.071-.014-3.071-.015-.129-.525c-.36-1.471-.834-1.637-4.683-1.64-1.825-.001-2.226.013-2.745.1-1.071.181-1.86.516-2.243.953-.275.313-.359.62-.33 1.207.04.866.3 1.289.894 1.46.566.162 2.425.3 5.645.418 5.064.187 7.853.614 9.035 1.385.524.342.88.745 1.156 1.307.297.606.392.965.473 1.776.12 1.204-.078 2.341-.57 3.27-.25.467-1.015 1.238-1.523 1.532-1.278.738-3.124 1.153-6.239 1.401-.978.078-5.881.113-7.023.05zm41.666.025c-3.506-.188-5.54-.564-7.023-1.298-.986-.488-1.526-1.02-2.053-2.017-.459-.868-.746-1.886-.954-3.375-.14-1.006-.14-3.76 0-4.69.292-1.947.912-3.334 1.894-4.238.482-.445.838-.67 1.53-.969 1.188-.512 2.817-.847 5.163-1.06 1.1-.1 5.904-.1 6.967 0 2.894.272 4.818.79 5.91 1.592 1.125.827 1.845 2.208 2.173 4.17.094.562.202 2.372.215 3.598l.002.208H86.201l-.038.203c-.067.36.02 1.736.14 2.227.208.84.594 1.436 1.17 1.804.872.556 3.04.823 5.775.711 2.822-.116 3.627-.413 4-1.478.064-.18.13-.522.147-.758l.032-.431h6.319l-.035.625c-.059 1.066-.202 1.567-.624 2.19-1.063 1.566-3.409 2.495-7.286 2.885-.812.081-4.927.152-5.885.1zM97.45 13.46c-.084-1.908-.582-2.585-2.132-2.899-1.504-.304-4.548-.36-6.178-.113-1.062.16-1.797.45-2.14.845-.413.475-.675 1.304-.73 2.306l-.034.625h11.248l-.034-.764zM28.68 16.058V7.39H35.009v17.336H28.68v-8.668zm39.75-3.695V0h6.33v24.726H68.43V12.363zM28.68 1.75V0H35.009v3.5H28.68V1.75z" />
          </svg>
        </router-link>
      </div>

      <div class="l-header-menu-btn c-button--inverted" @click="clickShowMenu">菜单</div>
      <div class="l-header-close-btn c-button--inverted" @click="clickCloseMenu">关闭</div>
      <div
        :class="['l-main-nav', 'animated--secondary',showMenu?'opened openToLeft':'',closeMenu?'closeToRight':'']"
        :style="{height:`${winHeight}px`}"
      >
        <div class="l-main-nav__top">
          <nav class="l-main-nav__items">
            <div class="content-asset">
              <router-link to="/" class="l-main-nav__item">分享中的美</router-link>
              <router-link to="/fondation" class="l-main-nav__item">慈善</router-link>
              <router-link to="/friedland" class="l-main-nav__item">公司文化</router-link>
              <router-link to="/expertise" class="l-main-nav__item">我们的专长</router-link>
            </div>
          </nav>
        </div>
        <div class="l-main-nav__bottom">
          <div class="content-asset">
            <router-link to="/" class="l-main-nav__content">
              <div class="l-main-nav__text">
                <span class="l-main-nav__subtitle">发现更多</span>
                <br />
                <span class="l-main-nav__title">希思黎产品</span>
              </div>
              <img src="../assets/imgs/CMS-pages/groupe/menu-format1.jpg" class="l-main-nav__image lazyloaded" />
            </router-link>
          </div>
        </div>
      </div>
    </header>
    <div class="page l-minisite">
      <div class="m-foundation js-section layout layout--full-width">
        <div class="c-minisite-banner text--white">
          <div class="c-minisite-banner__background">
            <picture class="c-minisite-banner__picture">
              <source
                media="(min-width: 1024px)"
                srcset="../assets/imgs/CMS-pages/foundation/img-3400@2x.jpg, ../assets/imgs/CMS-pages/foundation/img-3400@2x.jpg 2x"
              />
              <source
                media="(min-width: 768px)"
                srcset="../assets/imgs/CMS-pages/foundation/img-3400-md@2x.jpg, ../assets/imgs/CMS-pages/foundation/img-3400-md@2x.jpg 2x"
              />
              <source
                media="(min-width: 0px)"
                srcset="../assets/imgs/CMS-pages/foundation/img-3400-xs@2x.jpg, ../assets/imgs/CMS-pages/foundation/img-3400-xs@2x.jpg 2x"
              />

              <img
                class="image--full-width image--fit lazyloaded"
                srcset="../assets/imgs/CMS-pages/foundation/img-3400@2x.jpg 2x"
                src="../assets/imgs/CMS-pages/foundation/img-3400@2x.jpg"
              />
            </picture>
          </div>
          <div class="c-minisite-banner__content">
            <div class="layout c-container c-container--minisite">
              <div class="ms-row collapsed">
                <div class="col-xs-12 col-sm-12 col-md-12 col-md-offset-1">
                  <span class="c-minisite-title c-minisite-title--highlight">
                    基金会的目标：对内心珍视的事业
                    <br />发挥杠杆作用。
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="m-foundation js-section layout layout--full-width">
        <div
          class="c-minisite-content c-minisite-content--pre-carousel animatedParent animateOnce"
          style="background: #648993; color: #ffffff;"
        >
          <div class="layout c-container c-container--minisite">
            <div class="ms-row">
              <div class="col-xs-12 col-sm-7 col-md-4 col-md-offset-1">
                <div class="c-minisite-title c-minisite-title--secondary text--white">
                  我们的行动
                  <br />
                  头条
                </div>
                <div class="m-minisite__description heading-h4 text--white">
                  <p>2007年，Sisley希思黎化妆品公司都创始人兼所有者修伯特与伊丽莎白‧多纳诺创建了希思黎-多纳诺基金会。</p>
                </div>
              </div>
              <div class="col-xs-12 col-sm-4 col-sm-offset-1 col-md-2 col-md-offset-3">
                <div class="swiper-navigation-btns">
                  <button :class="['carousel__btn', 'carousel__btn--prev', 'slick-arrow', animating == -1 ? 'slick-arrow--animated' : '']" @click="slideTo(-1)">
                    <span :class="['slider__spinner', 'slider__spinner--black', animating == -1 ? 'animate-arrow' : '']">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="50" width="50" viewBox="0 0 55 55">
                        <circle cx="27.5" cy="27.5" r="26.5" stroke-width="2" />
                      </svg>
                    </span>
                  </button>
                  <button :class="['carousel__btn', 'carousel__btn--next', 'slick-arrow', animating == 1 ? 'slick-arrow--animated' : '']" @click="slideTo(+1)">
                    <span :class="['slider__spinner', 'slider__spinner--black', animating == 1 ? 'animate-arrow' : '']">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" height="50" width="50" viewBox="0 0 55 55">
                        <circle cx="27.5" cy="27.5" r="26.5" stroke-width="2" />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="m-minisite-section m-foundation-section js-section layout layout--full-width">
        <div class="c-minisite-content c-minisite-content--carousel c-minisite-content--bottom c-minisite-content--light">
          <div class="c-minisite-carousel__container text--black">
            <div class="layout c-minisite-carousel slick-initialized slick-slider">
              <div class="slick-list draggable">
                <swiper class="swiper-x-container" ref="kvSwiper" :options="swiperOpts">
                  <swiper-slide class="c-minisite-carousel__slide-inner" v-for="(item, index) in kvImages" :key="index">
                    <div class="row center-xs">
                      <img :src="item.url" />
                    </div>
                    <div class="row start-xs">
                      <div class="col-xs-12">
                        <div class="c-minisite-tile__title">
                          <span class="text--italic">LE SAMU SOCIAL DE PARIS</span>
                        </div>
                      </div>
                    </div>
                    <div class="row start-xs">
                      <div class="col-xs-12 col-sm-8">
                        <div class="c-minisite-carousel__text-secondary">
                          La Fondation Sisley-d’Ornano accompagne le Samusocial
                          en participant au financement des travaux du nouveau
                          centre d’hébergement d’urgence d’Evry-sur-Seine.
                          <br />
                          <br />
                          <a class="link-with-arrow m-foundation-content__projects-title--third" href="/" target="_blank">En savoir plus</a>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
            </div>
          </div>
          <div class="c-minisite-carousel__slider-info text--black center-xs">
            <!-- 页码 -->
            <div class="slider-info">
              <div class="slider-current">
                <div :class="['slider-next-item', animating != 0 ? 'shift-top' : '']">{{ (nextIndex + 1) | strPadding("l", 2, "0") }}</div>
                <div :class="['slider-current-item', animating != 0 ? 'shift-bottom' : '']">{{ (currIndex + 1) | strPadding("l", 2, "0") }}</div>
              </div>
              <div class="slider-num-spliter">/</div>
              <div class="slider-total">{{ kvImages.length | strPadding("l", 2, "0") }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="m-foundation js-section layout layout--full-width">
        <div class="m-foundation-content js-section">
          <div class="m-foundation-content__container-primary text--black" style="background: #fff;">
            <div class="layout c-container c-container--minisite animatedParent animateOnce">
              <div class="ms-row animated fadeIn delay-500 go">
                <div class="col-xs-12 col-sm-7 col-lg-4 col-lg-offset-1 first-sm">
                  <div class="c-minisite-title c-minisite-title--secondary">
                    <span class="m-fondation-content__carousel-text-primary--bold">基金会</span>
                    <br />
                    <span class="m-fondation-content__carousel-text-primary--bold">希思黎-多纳诺</span>
                    <br />
                    <span class="m-fondation-content__carousel-text-primary--italic">十年以上的承诺</span>
                  </div>
                </div>
                <div class="col-xs-12 first-xs col-sm-2 col-sm-offset-3 col-lg-1 col-lg-offset-5 m-fondation-content__box-primary-wrapper">
                  <div class="c-minisite-title c-minisite-title--secondary m-foundation-content__image-wrapper"></div>
                </div>
              </div>
              <div class="ms-row animated fadeIn delay-1000 go">
                <div class="col-xs-12 col-lg-5 col-lg-offset-1">
                  <div class="m-minisite__description heading-h4">
                    <p class="m-foundation-content__description-primary">隶属法国基金会（Fondation de France）的希思黎-多纳诺基金会致力于法国与外国的教育、文化、健康、环境与团结领域。</p>
                    <p class="m-foundation-content__description-secondary">治理</p>
                    <p class="m-foundation-content__description-primary">基金会委员会由公司的股东和员工以及多名专家和法国基金会代表组成。每年召开两次会议。</p>
                  </div>
                </div>
              </div>
              <div class="ms-row animated fadeIn delay-1000 go">
                <div class="col-xs-12 col-lg-5 col-lg-offset-1">
                  <img class="m-foundation-content__image--secondary lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/Foundation-02.jpg" />
                </div>
                <div class="col-xs-12 first-xs col-xs-offset-4 col-sm-offset-6 col-lg-5 last-lg col-lg-offset-1">
                  <img class="m-foundation-content__image--third lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/img-0975.png" />
                </div>
              </div>
              <div class="ms-row animated fadeIn delay-1000 go">
                <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-lg-5 col-lg-offset-6">
                  <div class="m-minisite__description m-foundation-content__text-block--right">
                    <div class="m-quote__sign m-quote__sign--first">
                      <img class="m-quote__sign-img lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/quote2.svg" />
                    </div>
                    <div class="m-quote__wrapper">
                      <div>我们的基金会由两个名字组成：即我们家族的姓氏和我们与员工共同发展的企业的名称。我们大家共同选择创建这家基金会，围绕我们想支持的事业开展行动。</div>
                      <div class="m-quote__author col-md-12">Sisley希思黎的创始人 修伯特与伊丽莎白‧多纳诺</div>
                    </div>
                    <div class="m-quote__sign m-quote__sign--last">
                      <img class="m-quote__sign-img lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/quote1.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="center-xs m-foundation-content__image-container" style="background: linear-gradient(to bottom,white 50%,white 100px,#648993 50%,#648993 100px);">
            <img class="center-xs m-foundation-content__image--fourth lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/03.jpg" />
          </div>
          <div class="c-foundation-wrapper animatedParent animateOnce" style="background: #648993; color: #fff;">
            <div class="layout c-container c-container--minisite animated fadeIn go">
              <div class="ms-row">
                <div class="col-xs-12 col-sm-6 col-lg-5 col-lg-offset-1">
                  <div class="m-minisite__description m-foundation-content__text-block--third" style="color: #fff;">
                    <div class="m-quote__sign m-quote__sign--start">
                      <img class="m-quote__sign-img lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/quote2.svg" />
                    </div>
                    <div class="m-quote__wrapper">
                      <div>希思黎-多纳诺基金会成立已有10多年，自成立时起即致力于推动对社会与环境有重大影响的项目。希望通过行动强调并可持续地支持公益事业。</div>
                      <div class="m-quote__author col-md-12">Sisley希思黎总裁 菲利浦•多纳诺</div>
                    </div>
                    <div class="m-quote__sign m-quote__sign--final">
                      <img class="m-quote__sign-img lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/quote1.svg" />
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 first-xs col-xs-offset-4 col-sm-6 last-sm col-sm-offset-0 col-lg-5 col-lg-offset-1">
                  <div class="m-minisite__description">
                    <img class="m-foundation-content__image--fifth lazyloaded" alt="Fondation" src="../assets/imgs/CMS-pages/foundation/04.jpg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="m-foundation js-section layout layout--full-width">
        <div class="m-foundation-content">
          <div class="c-minisite-content" style="background: #fff; color: #000;">
            <div class="layout c-container c-container--minisite">
              <div class="ms-row animatedParent animateOnce">
                <div class="col-xs-12 col-sm-6 col-lg-4 col-lg-offset-1 first-sm animated fadeIn delay-500 go">
                  <div class="c-minisite-title c-minisite-title--secondary">
                    <span class="m-fondation-content__carousel-text-primary--bold">“数说”基金会</span>
                  </div>
                </div>
                <div class="col-xs-12 col-xs-offset-4 first-xs col-sm-2 col-sm-offset-4 col-lg-1 col-lg-offset-5 animated fadeIn delay-1000 go">
                  <div class="c-minisite-title c-minisite-title--secondary"></div>
                </div>
              </div>
              <div class="ms-row animatedParent animateOnce">
                <div class="col-xs-12 col-lg-5 col-lg-offset-1 animated fadeIn delay-500 go">
                  <div class="m-minisite__description heading-h4">
                    <p class="m-foundation-content__description-primary">&nbsp;</p>
                  </div>
                </div>
              </div>
              <div class="ms-row center-xs animatedParent animateOnce">
                <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-500 go">
                  <svg width="200" height="100" style="border: 1px solid #375e68; border-bottom: 0; border-top-left-radius: 110px; border-top-right-radius: 110px; opacity: 0.5;">
                    <path id="path" />
                  </svg>
                  <div class="m-foundation-content__arch--text--zero">10年内支持的项目</div>
                  <div class="m-foundation-content__arch-text--primary">多于</div>
                  <div class="m-foundation-content__arch-text--secondary" style="color: #375e68;">200</div>
                  <!-- <div class="m-foundation-content__arch--text--third">10年内支持的项目</div> -->
                </div>
                <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-1000 go">
                  <svg width="200" height="100" style="border: 1px solid #375e68; border-bottom: 0; border-top-left-radius: 110px; border-top-right-radius: 110px; opacity: 0.5;">
                    <path id="path" />
                  </svg>
                  <div class="m-foundation-content__arch--text--zero">每年捐赠欧元</div>
                  <div class="m-foundation-content__arch-text--primary">多于</div>
                  <div class="m-foundation-content__arch-text--secondary" style="color: #53818d;">百万</div>
                  <!-- <div class="m-foundation-content__arch--text--third">每年捐赠欧元</div> -->
                </div>
              </div>
              <div class="ms-row center-xs animatedParent animateOnce">
                <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-500 go">
                  <svg width="200" height="100" style="border: 1px solid #375e68; border-bottom: 0; border-top-left-radius: 110px; border-top-right-radius: 110px; opacity: 0.5;">
                    <path id="path" />
                  </svg>
                  <div class="m-foundation-content__arch--text--zero">每年遴选（春 / 秋）</div>
                  <div class="m-foundation-content__arch-text--primary"></div>
                  <div class="m-foundation-content__arch-text--secondary" style="color: #699aa6;">2个委员会</div>
                  <!-- <div class="m-foundation-content__arch--text--third">每年遴选（春 / 秋）</div> -->
                </div>
              </div>
              <div class="ms-row center-xs animatedParent animateOnce">
                <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-500 go">
                  <svg width="200" height="100" style="border: 1px solid #375e68; border-bottom: 0; border-top-left-radius: 110px; border-top-right-radius: 110px; opacity: 0.5;">
                    <path id="path" />
                  </svg>
                  <div class="m-foundation-content__arch--text--zero">希思黎员工提出的项目</div>
                  <div class="m-foundation-content__arch-text--primary">多于</div>
                  <div class="m-foundation-content__arch-text--secondary" style="color: #8abbc7;">10%</div>
                  <!-- <div class="m-foundation-content__arch--text--third">希思黎员工提出的项目</div> -->
                </div>
                <div class="m-foundation-content__arch-container col-xs-12 col-sm-6 animated fadeIn delay-1000 go">
                  <svg width="200" height="100" style="border: 1px solid #375e68; border-bottom: 0; border-top-left-radius: 110px; border-top-right-radius: 110px; opacity: 0.5;">
                    <path id="path" />
                  </svg>
                  <div class="m-foundation-content__arch--text--zero">支持方向</div>
                  <div class="m-foundation-content__arch-text--primary"></div>
                  <div class="m-foundation-content__arch-text--secondary" style="color: #b6d8e0;">5大</div>
                  <!-- <div class="m-foundation-content__arch--text--third">支持方向</div> -->
                </div>
              </div>
              <div class="ms-row m-foundation-content__actions-container animatedParent animateOnce">
                <div class="col-xs-12 col-sm-6 col-lg-4 col-lg-offset-1 animated fadeIn delay-500 go">
                  <div class="c-minisite-title c-minisite-title--secondary">
                    <span class="m-fondation-content__carousel-text-primary--bold">发现</span>
                    <br />
                    <span class="m-fondation-content__carousel-text-primary--italic">我们的行动</span>
                  </div>
                </div>
                <div class="col-sm-2 col-sm-offset-4 col-lg-1 col-lg-offset-5 hide-for-xs-only animated fadeIn delay-500 go">
                  <div class="c-minisite-title c-minisite-title--secondary"></div>
                </div>
              </div>
              <div class="ms-row animatedParent animateOnce">
                <div class="col-xs-12 col-sm-12 col-lg-5 col-lg-offset-1 animated fadeIn delay-500 go">
                  <div class="m-minisite__description heading-h4">
                    <p class="m-foundation-content__description-primary">基金会在五大领域内开展工作，每个领域都有一支力量：</p>
                  </div>
                </div>
              </div>
              <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
                <div class="col-xs-12 animated fadeIn delay-500 go">
                  <div class="m-minisite__description">
                    <span class="m-foundation-content__projects-title--primary">团结</span>
                    <br />
                    <span class="m-foundation-content__projects-title--secondary">帮助有困难的妇女</span>
                    <br />
                    <a class="link-with-arrow m-foundation-content__projects-title--third">查看项目</a>
                    <br />
                  </div>
                </div>
              </div>
              <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
                <div class="col-xs-12 animated fadeIn delay-500 go">
                  <div class="m-minisite__description">
                    <span class="m-foundation-content__projects-title--primary">健康</span>
                    <br />
                    <span class="m-foundation-content__projects-title--secondary">对心理与精神疾病有所作为</span>
                    <br />
                    <a class="link-with-arrow m-foundation-content__projects-title--third">查看项目</a>
                    <br />
                  </div>
                </div>
              </div>
              <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
                <div class="col-xs-12 animated fadeIn delay-500 go">
                  <div class="m-minisite__description">
                    <span class="m-foundation-content__projects-title--primary">教育</span>
                    <br />
                    <span class="m-foundation-content__projects-title--secondary">应对学业失败并促进青年融入</span>
                    <br />
                    <a class="link-with-arrow m-foundation-content__projects-title--third">查看项目</a>
                    <br />
                  </div>
                </div>
              </div>
              <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
                <div class="col-xs-12 animated fadeIn delay-500 go">
                  <div class="m-minisite__description">
                    <span class="m-foundation-content__projects-title--primary">文化</span>
                    <br />
                    <span class="m-foundation-content__projects-title--secondary">发展文化项目作为包容性杠杆</span>
                    <br />
                    <a class="link-with-arrow m-foundation-content__projects-title--third">查看项目</a>
                    <br />
                  </div>
                </div>
              </div>
              <div class="ms-row center-xs m-foundation-content__projects-container animatedParent animateOnce">
                <div class="col-xs-12 animated fadeIn delay-500 go">
                  <div class="m-minisite__description">
                    <span class="m-foundation-content__projects-title--primary">环境</span>
                    <br />
                    <span class="m-foundation-content__projects-title--secondary">为生物多样性做贡献</span>
                    <br />
                    <a class="link-with-arrow m-foundation-content__projects-title--third">查看项目</a>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import utils from "@/utils/index";
export default {
  components: { swiper, swiperSlide },
  data() {
    return {
      kvSwiper: {},
      swiperOpts: {
        loop: true,
        speed: 1000,
        slidesPerView: 1,
        autoplay: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        breakpoints: {
          768: {
            slidesPerView: 1,
            centeredSlides: false,
            centeredSlidesBounds: false,
          },
          1920: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          }
        }
      },
      kvImages: [
        { url: require("@/assets/imgs/CMS-pages/foundation/kisany.jpg") },
        { url: require("@/assets/imgs/CMS-pages/foundation/pitie.jpg") },
        { url: require("@/assets/imgs/CMS-pages/foundation/samu-social.jpg") }
      ],
      animating: 0,
      currIndex: 0,
      nextIndex: 0,
      total: 3,
      showMenu: false,
      closeMenu: false,
      winHeight: 0,
    };
  },
  mounted() {
    if (this?.$refs?.kvSwiper?.swiper?.realIndex) {
      this.currIndex = this.$refs.kvSwiper.swiper.realIndex;
    }
    this.$nextTick(() => {
      this.winHeight = document.documentElement.clientHeight;
    });
  },
  filters: {
    strPadding(str, direction, maxLength, fillString) {
      return utils.strPadding(str, direction, maxLength, fillString);
    }
  },
  methods: {
    // 切换Swiper
    slideTo(direction) {
      if (this.kvSwiper?.animating) return false;
      let isLoop = this.$refs?.kvSwiper?.swiper?.params?.loop;
      let newNext = -1;
      if (direction === 1) {
        newNext = this.$refs.kvSwiper.swiper.realIndex + 1;
        if (newNext <= this.total - 1) {
          //
        } else if (isLoop && newNext > this.total - 1) {
          newNext = 0;
        } else {
          return;
        }
        this.nextIndex = newNext;
        this.$refs.kvSwiper.swiper.slideNext();
      } else {
        newNext = this.$refs.kvSwiper.swiper.realIndex - 1;
        if (newNext >= 0) {
          //
        } else if (isLoop && newNext < 0) {
          newNext = this.total - 1;
        } else {
          return;
        }
        this.nextIndex = newNext;
        this.$refs.kvSwiper.swiper.slidePrev();
      }
      //
      this.animating = direction;
      this.resetAnimationStatus(1000, () => {
        this.currIndex = newNext;
      });
    },
    // 重置动画标识状态
    resetAnimationStatus(time, callback) {
      setTimeout(() => {
        this.animating = 0;
        utils.isFunction(callback) && callback();
      }, time || 0);
    },
    clickShowMenu() {
      this.showMenu = true;
      this.closeMenu = false;
    },
    clickCloseMenu() {
      this.closeMenu = true;
      this.showMenu = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.gl-flex { display: flex; justify-content: flex-start; align-items: stretch; align-content: stretch; flex-flow: row nowrap; }
.l-header__wrapper { width: 100%; height: 0; position: fixed; top: 0; z-index: 12; display: flex; justify-content: space-between; }
.l-header-logo { width: auto; height: 2.5625rem; z-index: 11; }
.l-header-logo__link { margin: 2.5625rem 0 0 1.875rem; display: block; }
.l-minisite { background: #fff; min-height: 100vh; padding: 0; }
.page { position: relative; overflow-x: hidden; }
.c-minisite-banner__background { height: 40.8125rem; overflow: hidden; }
.c-minisite-banner__picture { display: flex; height: 100%; }
.c-minisite-banner__content { width: 100%; position: absolute; bottom: 25%; }
.c-container--minisite { padding: 0 3.0625rem; }
.c-container { padding: 0 1rem; }
.c-minisite-title--highlight {
  padding: 0.1875rem 0; margin-left: 0.4375rem; color: #fff; background-color: #000;
  box-shadow: 0.4375rem 0 0 #000, -0.4375rem 0 0 #000; box-decoration-break: clone;
}
.c-minisite-content--pre-carousel { padding-bottom: 10.375rem; }
.c-minisite-content { padding: 8.8125rem 0 9.375rem; }
.c-minisite-title--secondary { font-size: 3.125rem; font-family: PlayfairDisplay-Bold, arial, sans-serif; line-height: 1; margin-bottom: 2.5rem; }
.text--italic { font-family: PlayfairDisplay-Italic, arial, sans-serif; font-size: inherit; line-height: inherit; }
.text--white { color: #fff; }
.c-minisite-carousel__container { height: auto; position: relative; top: -9.375rem; left: 0; margin-bottom: -9.375rem; }
.slick-arrow {
  background-color: transparent; transition: background-color 0.2s linear; cursor: pointer;
  &::after {
    content: ""; background: url(../assets/imgs/icons/arrow-big.svg) no-repeat 50%; display: block; width: 0.875rem; height: 0.875rem;
  }
}
.slider__spinner {
  position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; font-size: 0;
  circle { fill: none; stroke: #fff; stroke-linecap: square; }
  &.animate-arrow svg { animation: rotate-forward 1s ease-out; }
  &.animate-arrow circle { animation: animate-arrow 1s cubic-bezier(0.8, 0, 0.9, 1); }
}
.slider__spinner--black circle { stroke: #fff; }
.swiper-navigation-btns {
  display: flex; justify-content: center; align-items: center; padding: 28px 0;
  .slick-arrow {
    position: relative; width: 3.125rem; height: 3.125rem; padding: 0; border: 0.0625rem solid #dfdfdf; border-radius: 50%; transition: none;
    &::after {
      position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);
      background: url(../assets/imgs/icons/arrow-bigger-white.svg) no-repeat 50%;
    }
  }
  .carousel__btn {
    .slider__spinner {
      overflow: hidden;
      svg {
        transform: rotate(-90deg);
        circle { stroke-dasharray: 1 226.19467px; stroke-dashoffset: -226.19467px; }
      }
    }
  }
  .carousel__btn--prev {
    &::after { transform: translate(-50%, -50%) rotate(90deg); }
    margin-right: 20px;
  }
  .carousel__btn--next {
    &::after { transform: translate(-50%, -50%) rotate(-90deg); }
  }
}
.slider-info {
  display: flex; justify-content: center; align-items: center; margin: 0 15px; color: #000; font-size: 0.8125rem; line-height: 1.5625rem;
  .slider-current {
    position: relative; overflow: hidden; width: 1.125rem; height: 1.5625rem;
    font-family: HelveticaNeueLTW05-45Light, arial, sans-serif; font-size: 0.8125rem; text-align: right;
    .slider-next-item { position: absolute; top: -100%; right: 0; }
    .slider-current-item { position: absolute; top: 0; right: 0; }
    .shift-top { animation: shift-top 1s linear; }
    .shift-bottom { animation: shift-bottom 1s linear; }
  }
  .slider-num-spliter { margin: 0 4px; }
  .slider-total { font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif; text-align: left; width: 1.125rem; }
}
.c-minisite-carousel__slide-inner { height: auto; max-width: 36.8125rem; padding: 0.625rem 0; }
.c-minisite-carousel__img { max-height: 11.5625rem; max-width: 17.3125rem; margin-bottom: 1.25rem; }
.c-minisite-tile__title { font-family: PlayfairDisplay-Bold, arial, sans-serif; font-size: 1.5625rem; line-height: 1; margin-bottom: 1.25rem; }
.link-with-arrow { position: relative; cursor: pointer; }
.m-foundation-content .c-container--minisite .c-minisite-title--secondary { margin-bottom: 1.5625rem; }
.m-fondation-content__carousel-text-primary--bold { font-family: PlayfairDisplay-Bold, arial, sans-serif; }
.m-fondation-content__carousel-text-primary--italic { font-family: PlayfairDisplay-Italic, arial, sans-serif; }
.m-foundation-content .m-foundation-content__description-primary { font-size: 1rem; font-family: HelveticaNeueLTW05-45Light, arial, sans-serif; line-height: 1.5; }
.m-foundation-content .m-foundation-content__description-secondary { font-size: 1.25rem; font-family: PlayfairDisplay-Bold, arial, sans-serif; }
.m-foundation-content .m-foundation-content__image--third { margin-top: 3.125rem; max-width: 14.3125rem; }
.m-foundation-content .m-foundation-content__image--secondary { margin: 2.5rem 0 0 -3.75rem; max-width: 16.3125rem; }
.m-foundation-content__container-primary .m-foundation-content__text-block--right { padding-top: 5.1875rem; margin: 0 0 3.625rem; }
.m-foundation-content__text-block--right, .m-foundation-content__text-block--third {
  display: flex; align-self: center; justify-content: center; margin-left: auto; margin-right: auto;
  font-size: 1.25rem; line-height: 1.4; font-family: PlayfairDisplay-Italic, arial, sans-serif;
}
.m-foundation-content__text-block--right .m-quote__sign--first, .m-foundation-content__text-block--third .m-quote__sign--first {
  margin-top: -1.75rem; margin-right: 1rem; margin-left: -2rem;
}
.m-foundation-content__text-block--right .m-quote__sign, .m-foundation-content__text-block--third .m-quote__sign { width: 1rem; }
.m-foundation-content__text-block--right .m-quote__sign-img, .m-foundation-content__text-block--third .m-quote__sign-img { width: 100%; }
.m-foundation-content__text-block--right .m-quote__wrapper, .m-foundation-content__text-block--third .m-quote__wrapper { width: 100%; }
.m-foundation-content__text-block--right .m-quote__author, .m-foundation-content__text-block--third .m-quote__author {
  font-size: 0.8125rem; font-family: HelveticaNeueLTW05-45Light, arial, sans-serif; margin-top: 5.3125rem; padding-left: 0;
}
.m-foundation-content__text-block--right .m-quote__sign--last, .m-foundation-content__text-block--third .m-quote__sign--last {
  margin-bottom: 1.875rem; margin-left: 1rem; margin-right: -2rem; display: flex; align-items: flex-end;
}
.m-foundation-content .m-foundation-content__image-container .m-foundation-content__image--fourth { max-width: 17.3125rem; }
.c-foundation-wrapper { padding: 3.75rem 0 0; }
.m-foundation-content .m-foundation-content__image--fifth { max-width: 14.3125rem; }
.m-foundation-content__text-block--right .m-quote__sign--start, .m-foundation-content__text-block--third .m-quote__sign--start {
  margin-top: -1.875rem; margin-right: 1rem; margin-left: -2rem;
}
.m-foundation-content__text-block--right .m-quote__sign--final, .m-foundation-content__text-block--third .m-quote__sign--final {
  margin-bottom: 1.5625rem; margin-left: 1rem; margin-right: -2rem; display: flex; align-items: flex-end;
}
.m-foundation-content .m-foundation-content__arch-container { padding-top: 3.4375rem; }
.m-foundation-content  .m-foundation-content__arch--text--zero {
  font-size: 1rem; margin: -2.5rem 0 1rem 0;
}
.m-foundation-content .m-foundation-content__arch-text--secondary {
  font-family: PlayfairDisplay-Bold, arial, sans-serif; line-height: 1; font-size: 4.375rem;
}
.m-foundation-content .m-foundation-content__arch--text--third { margin-top: 1.5625rem; }
.m-foundation-content .m-foundation-content__actions-container { padding-top: 11.875rem; }
.m-foundation-content .m-foundation-content__projects-container { padding-top: 6.25rem; }
.m-foundation-content .m-foundation-content__projects-title--primary {
  font-family: PlayfairDisplay-Bold, arial, sans-serif;
  font-size: 1.875rem; font-style: normal; font-stretch: normal; line-height: normal; letter-spacing: normal;
}
.m-foundation-content .m-foundation-content__projects-title--secondary {
  font-size: 1.25rem; font-style: normal; font-stretch: normal; line-height: normal; letter-spacing: normal;
}
.link-with-arrow:hover { color: #c4926d; }
.l-header-close-btn, .l-header-menu-btn {
  width: 4.8125rem; height: 0.9375rem; padding: 0.625rem; display: table;
  color: #fff; font-size: 0.75rem; letter-spacing: 0.0625rem; line-height: 1;
  position: absolute; top: 2.75rem; right: 0; z-index: 11;
}
.c-button--inverted {
  transform: rotate(90deg); text-transform: uppercase; font-family: HelveticaNeueLTW05-75Bold, arial, sans-serif; align-self: flex-end; cursor: pointer;
}
.opened .l-header-menu-btn { animation: fadeOut 0.5s linear forwards; opacity: 0; }
.opened .l-header-close-btn { animation: fadeIn 1s linear forwards; display: table; }
.l-header-close-btn { color: #fff; display: none; }
.l-main-nav { position: absolute; top: 0; left: 100%; width: 100%; height: 100vh; }
.l-main-nav__top { width: 100%; height: 67%; display: flex; flex-direction: column; background-color: #313131; }
.l-main-nav__bottom { width: 100%; height: 33%; background: #f6f6f6; position: relative; }
.l-main-nav__items { display: flex; flex-direction: column; flex-grow: 1; justify-content: flex-end; padding: 14.5vh 14.5% 8.25vh; }
.l-main-nav__item {
  display: block; margin-bottom: 3.6vh; font-family: PlayfairDisplay-Italic, arial, sans-serif;
  color: #fff; font-size: 1.375rem; line-height: 1.64; text-decoration: none;
  &:hover { text-decoration: underline; }
}
.l-main-nav__content { text-align: center; display: flex; }
.l-main-nav__text { width: 90%; position: absolute; top: 3.8vh; left: 50%; z-index: 1; transform: translateX(-50%); }
.l-main-nav__subtitle { font-family: PlayfairDisplay-Bold, arial, sans-serif; font-size: 1.25rem; }
.l-main-nav__title { font-family: HelveticaNeueLTW05-45Light, arial, sans-serif; font-size: 1.5625rem; font-weight: 300; line-height: 1.4; }
.l-main-nav__image { max-height: 35.39vh; position: absolute; bottom: 0; left: 50%; transform: translate(-50%); }

@media screen and (min-width: 48em) {
  .l-header-logo__link { margin: 2.75rem 0 0 3rem; }
  .c-minisite-banner__background { height: 64.25rem; }
  .c-container--minisite { padding: 0 3.875rem; }
  .c-container { padding: 0 10.75rem; }
  .c-minisite-title--highlight { font-size: 3.75rem; line-height: 1.16; padding: 0.125rem 0; }
  .c-minisite-title { font-size: 2.5rem; line-height: 1.63; }
  .c-minisite-content--pre-carousel { padding-bottom: 18.75rem; }
  .c-minisite-content { padding: 6.875rem 0 6.25rem; }
  .c-minisite-title--secondary { font-size: 3.75rem; margin-bottom: 3.3125rem; }
  .c-minisite-carousel__container { height: auto; position: relative; top: -18.75rem; left: 0; margin-bottom: -18.75rem; }
  .c-minisite-carousel__slide-inner { height: auto; max-width: 36.8125rem; padding: 0.625rem 0; }
  .c-minisite-carousel__img { max-height: 24.5625rem; max-width: 36.8125rem; margin-bottom: 1.875rem; }
  .m-foundation-content .c-container--minisite .c-minisite-title--secondary { margin-bottom: 2.1875rem; }
  .m-foundation-content .m-foundation-content__image--third { max-width: 23.25rem; margin-left: 2.1875rem; }
  .m-foundation-content .m-foundation-content__image--secondary { max-width: 19.75rem; margin: -15.625rem 0 0 -4.0625rem; }
  .m-foundation-content__container-primary .m-foundation-content__text-block--right { padding-top: 3.625rem; }
  .m-foundation-content__text-block--right, .m-foundation-content__text-block--third { order: 2; }
  .m-foundation-content__text-block--right .m-quote__sign--first, .m-foundation-content__text-block--third .m-quote__sign--first { margin-top: -0.75rem; margin-left: -2.5rem; }
  .m-foundation-content__text-block--right .m-quote__sign, .m-foundation-content__text-block--third .m-quote__sign { width: 1.5625rem; }
  .m-foundation-content__text-block--right .m-quote__author, .m-foundation-content__text-block--third .m-quote__author { margin-top: 3.75rem; }
  .m-foundation-content__text-block--right .m-quote__sign--last, .m-foundation-content__text-block--third .m-quote__sign--last { margin-right: -2.5rem; margin-bottom: 1.5625rem; }
  .m-foundation-content__text-block--right .m-quote__sign, .m-foundation-content__text-block--third .m-quote__sign { width: 1.5625rem; }
  .m-foundation-content .m-foundation-content__image-container .m-foundation-content__image--fourth { max-width: 26.3125rem; }
  .c-foundation-wrapper { padding: 6.25rem 0 1.25rem; }
  .m-foundation-content .m-foundation-content__image--fifth { max-width: 19.8125rem; margin-left: 5.625rem; }
  .m-foundation-content__text-block--right .m-quote__sign--start, .m-foundation-content__text-block--third .m-quote__sign--start { margin-top: -0.75rem; margin-left: -2.5rem; }
  .m-foundation-content__text-block--right .m-quote__sign--final, .m-foundation-content__text-block--third .m-quote__sign--final { margin-right: 0; margin-left: -1.4375rem; margin-bottom: 1.25rem; }
  .m-foundation-content  .m-foundation-content__arch--text--zero { font-size: 0.875rem; }
  .m-foundation-content .m-foundation-content__arch-text--secondary { line-height: 4.625rem; font-size: 3.75rem; }
  .l-header-close-btn, .l-header-menu-btn { top: 3.625rem; right: 1rem; }
  .l-main-nav { max-width: 35.625rem; }
  .l-main-nav__items { align-self: center; justify-content: center; padding: 0; }
  .l-main-nav__item { margin-bottom: 3.7vh; line-height: 1.2; font-size: 1.5625rem; }
  .l-main-nav__content { height: 33vh; }
  .l-main-nav__title { font-size: 1.875rem; line-height: 1.47; }
  .l-main-nav__image { max-height: 33vh; }
}
@media screen and (min-width: 64em) {
  .l-header-logo__link { margin: 3.75rem 0 0 5rem; }
  .page { overflow: hidden; }
  .c-minisite-banner__background {    height: 69.9375rem; height: 100vh; }
  .c-container--minisite { padding: 0; }
  .c-container { padding: 0 3.875rem; }
  .c-minisite-title { font-size: 2.5rem; }
  .c-minisite-content { padding: 11.875rem 0 6.8125rem; }
  .c-minisite-title--secondary { margin-bottom: 3.125rem; }
  .slick-arrow--animated:before { transform: rotate(225deg); animation: colorTop 1s; }
  .slick-arrow:hover {
    background-color: #fff; border-color: #fff;
    &::after {
      background: url(../assets/imgs/icons/arrow-bigger.svg) no-repeat 50%;
    }
    &.slick-arrow--animated {
      background-color: transparent; border-color: #dfdfdf;
      &::after {
        background: url(../assets/imgs/icons/arrow-bigger.svg) no-repeat 50%;
      }
    }
  }
  .c-minisite-carousel__slide-inner { height: auto; max-width: 49.625rem; padding: 2.5rem 0; }
  .c-minisite-carousel__img { max-height: 39.75rem; max-width: 49.625rem; }
  .m-foundation-content .m-foundation-content__image--third { margin-left: 10.9375rem; }
  .m-foundation-content .m-foundation-content__image--fifth { margin-left: 13.75rem; }
  .m-foundation-content  .m-foundation-content__arch--text--zero { font-size: 1rem; }
  .m-foundation-content .m-foundation-content__arch-text--secondary { line-height: 4.25rem; }
  .l-header-close-btn, .l-header-menu-btn { top: 4.625rem; right: 3rem; }
  .l-main-nav { max-width: 46.875rem; }
  .l-main-nav__item { margin-bottom: 2.75rem; line-height: 1.2; font-size: 1.5625rem; }
  .l-main-nav__text { top: 2.5rem; }
}
@media screen and (min-width: 75em) {
  .c-container { padding: 0; }
  .m-foundation-content .m-foundation-content__image--third { max-width: 24.3125rem; margin: -11.25rem 0 0; }
  .m-foundation-content .m-foundation-content__image--secondary { max-width: 24.3125rem; margin: 10.75rem 0 0; }
  .m-foundation-content__container-primary .m-foundation-content__text-block--right { padding-top: 0; margin-top: -7.5rem; }
  .m-foundation-content__text-block--right, .m-foundation-content__text-block--third {
    font-size: 1.25rem; line-height: 1.4; order: 0; display: flex; justify-content: center; margin: 0;
  }
  .m-foundation-content__text-block--right .m-quote__sign--first, .m-foundation-content__text-block--third .m-quote__sign--first { margin-right: 1.375rem; margin-left: -3rem; }
  .m-foundation-content__text-block--right .m-quote__author, .m-foundation-content__text-block--third .m-quote__author { font-size: 0.8125rem; }
  .m-foundation-content__text-block--right .m-quote__author, .m-foundation-content__text-block--third .m-quote__author { margin-top: 3.125rem; }
  .m-foundation-content__text-block--right .m-quote__sign--last, .m-foundation-content__text-block--third .m-quote__sign--last { margin-right: 0; margin-left: -1.625rem; }
  .m-foundation-content .m-foundation-content__image-container .m-foundation-content__image--fourth { max-width: 37rem; }
  .c-foundation-wrapper { padding: 8.75rem 0 5.9375rem; }
  .m-foundation-content .m-foundation-content__image--fifth { max-width: 24.3125rem; margin-left: 0; }
  .m-foundation-content .m-foundation-content__projects-title--primary { font-size: 2.5rem; }
  .m-foundation-content .m-foundation-content__projects-title--secondary { font-size: 2rem; }
}
@keyframes colorTop {
  0% { border-left-color: #fff; }
  25% { border-top-color: #fff; }
  50% { border-right-color: #fff; }
}
</style>
